import script from "./FranchiseLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseLeaderboard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueButton from "@/components/neue/NeueButton.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import ReportDelta from "@/components/reports/ReportDelta.vue";
import TablistGrid from "@/components/neue/TablistGrid.vue";
import TablistHeader from "@/components/neue/TablistHeader.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
script.components = Object.assign({}, { NeueButton, NeueTablist, ReportDelta, TablistGrid, TablistHeader, TablistRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueButton, NeueTablist, ReportDelta, TablistGrid, TablistHeader, TablistRow }, script.__o.components);}